import React, { Component } from "react";
import { Modal, List, Image, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

class SidebarAttendeeModal extends Component {
    render() {
        const { attendees, open, close } = this.props;
        return (
            <Modal size="mini" open={open} onClose={close}>
                <Modal.Header>List of Attendees</Modal.Header>
                <Modal.Content>
                    <List vertical>
                        {attendees.map(attendee => (
                            <List.Item key={attendee.id}>
                                <div>
                                    <Image
                                        as={Link}
                                        to={`/profile/${attendee.id}`}
                                        size="mini"
                                        circular
                                        src={attendee.values.photoURL}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "20px"
                                        }}
                                    >
                                        {attendee.values.displayName}
                                    </span>
                                </div>
                            </List.Item>
                        ))}
                    </List>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        positive
                        icon="checkmark"
                        labelPosition="right"
                        content="Okay"
                        onClick={close}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default SidebarAttendeeModal;
